import { useMemo } from "react";

import type { ScreenMembersOnResetPassword } from "@auth0/auth0-acul-js";
import ResetPasswordInstance from "@auth0/auth0-acul-js/reset-password";

import { executeSafely } from "../utils/helpers/executeSafely";

export const useResetPasswordManager = () => {
  const resetPasswordInstance = useMemo(() => new ResetPasswordInstance(), []);

  const { screen, transaction } = resetPasswordInstance;
  const { texts, data, captchaImage } = screen;

  const handleResetPassword = async (
    password: string,
    confirmPassword: string,
    captcha?: string
  ): Promise<void> => {
    const options: {
      "password-reset": string;
      "re-enter-password": string;
      captcha?: string;
    } = {
      "password-reset": password || "",
      "re-enter-password": confirmPassword || "",
    };

    if (screen.isCaptchaAvailable && captcha?.trim()) {
      options.captcha = captcha.trim();
    }

    executeSafely(
      "ResetPassword submit new password",
      () => resetPasswordInstance.resetPassword(options)
    );
  };

  return {
    resetPasswordInstance,
    handleResetPassword,
    texts: (texts || {}) as ScreenMembersOnResetPassword["texts"],
    errors: resetPasswordInstance.getError(),
    isCaptchaAvailable: screen.isCaptchaAvailable === true,
    captchaImage,
    loginLink: screen.links?.login || null,
    transactionState: transaction.state || "",
    prefilledIdentifier: data?.username || "",
  };
};
